import { render, staticRenderFns } from "./IriMap.vue?vue&type=template&id=09d5d76e&scoped=true"
import script from "./IriMap.vue?vue&type=script&lang=js"
export * from "./IriMap.vue?vue&type=script&lang=js"
import style0 from "./IriMap.vue?vue&type=style&index=0&id=09d5d76e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d5d76e",
  null
  
)

export default component.exports